<div *ngIf="blogPost" class="content-pages-list-article-container">
  <div class="content-pages-list-image-container">
    <a
      [ngClass]="imgCssClass"
      [routerLink]="routePath"
      [title]="blogPost.title.rendered"
      class="content-pages-list-article-image"
    >
      <app-media-item
        [image]="blogPost.acf.mainImage"
        [isPriority]="index === 0"
      ></app-media-item>
    </a>
    <div
      *ngIf="blogPost && blogPost.acf && blogPost.acf.isSponsored"
      class="sponsored-label"
    >
      Sponsrad
    </div>
  </div>
  <div class="content-pages-article-text">
    <a
      [ngClass]="titleCssClass"
      [routerLink]="routePath"
      [title]="blogPost.title.rendered"
      class="content-pages-article-title"
    >
      <h2 [innerHTML]="blogPost.title.rendered" class="text-2xl font-bold"></h2>
    </a>
    <div class="content-pages-date mb-4">
      <app-ui-icon color="var(--grey-1)" name="clock" size="sm"></app-ui-icon>
      <span class="content-pages-article-date">{{ publishDate }}</span>
      <span *ngIf="postTags.length > 0" [innerHTML]="postTagsString"></span>
    </div>
    <div
      [innerHTML]="blogPost.excerpt.rendered"
      class="content-pages-article-description mb-4"
    ></div>
  </div>
</div>
